import React from 'react';

import { colorsPalette } from '../../theme';

const VideoClipIcon = ({ color = colorsPalette.white, ...rest }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      color={color}
    >
      <path
        d="M0.5 3.33325C0.5 2.50483 1.17157 1.83325 2 1.83325H14C14.8284 1.83325 15.5 2.50482 15.5 3.33325V3.99992V12.6666C15.5 13.495 14.8284 14.1666 14 14.1666H2C1.17157 14.1666 0.5 13.495 0.5 12.6666V3.99992V3.33325Z"
        stroke="currentColor"
      />
      <path
        d="M11.125 9.04984C11.2024 9.00518 11.25 8.92265 11.25 8.83333C11.25 8.74402 11.2024 8.66149 11.125 8.61683L6.875 6.16309C6.79765 6.11843 6.70235 6.11843 6.625 6.16309C6.54765 6.20775 6.5 6.29028 6.5 6.37959L6.5 11.2871C6.5 11.3764 6.54765 11.4589 6.625 11.5036C6.70235 11.5482 6.79765 11.5482 6.875 11.5036L11.125 9.04984Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.5"
        stroke-linejoin="round"
      />
      <path
        d="M0 4V4.66667H16V4C16 2.89543 15.1046 2 14 2H2C0.895431 2 0 2.89543 0 4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default VideoClipIcon;
